import { IStore } from '../../../app/store'
import SelectCourtCase from "../../usecases/select-court/select-court.case";
import MapRepository from "../gateways/map.repository";
import CourtEntity from "../../../courts/entities/court.entity";
import AddCourtToFavoriteCase from "../../usecases/add-court-to-favorite/add-court-to-favorite.case";
import CourtsApiGateway from "../gateways/courts-api.gateway";

export default class CourtPopupController {
  private readonly store: IStore
  private readonly selectCourtCase: SelectCourtCase
  private readonly addCourtToFavoriteCase: AddCourtToFavoriteCase

  constructor (store: IStore) {
    this.store = store
    const mapRepo = new MapRepository(store)
    const courtApi = new CourtsApiGateway(store)

    this.selectCourtCase = new SelectCourtCase(mapRepo, courtApi)
    this.addCourtToFavoriteCase = new AddCourtToFavoriteCase(courtApi, mapRepo)
  }

  selectCourt (court: CourtEntity) {
    this.selectCourtCase.execute(court)
  }

  closeModal () {
    this.selectCourtCase.execute(null)
  }

  addCourtToFavorite (isFavorite: boolean) {
    this.addCourtToFavoriteCase.execute(isFavorite)
  }
}
